import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import '../../node_modules/slick-carousel/slick/slick.js';
import '../../node_modules/jquery.formstyler/jquery.formstyler.js';
import '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import noUiSlider from '../../node_modules/nouislider/distribute/nouislider.min.js';
import datepicker from 'js-datepicker';
import 'nodelist-foreach-polyfill';

$(() => {
	const $b = $('body');
	const $w = $(window);
	svg4everybody();
	// front slick slider
	$('.slider__sl').slick({
		dots: true,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear'
	});
	// sticky header
	const stickyOffset = $('.header').height();
	const $header = $('.header-sticky');
	$w.scroll(function (){
		if ($(window).scrollTop() >= stickyOffset){
			$header.addClass('header-sticky_show');
		}else {
			$header.removeClass('header-sticky_show');
		}
	});
	// to top scroll
	$b.on('click', '.js-top', function (e){
		e.preventDefault();
		$('html, body').animate({
			scrollTop: 0
		}, 1000);
	});
	// search focus
	const $search = $('.search_dark');
	$search.find('.search__input').on('focus', function (){
		$search.addClass('search_focus');
	});
	$search.find('.search__input').on('blur', function (){
		$search.removeClass('search_focus');
	});
	$b.on('click', '.menu__link_hamburger', function (e){
		e.preventDefault();
		$('.header-mobile').toggleClass('header-mobile_opened');
	});
	$b.on('click', '.header-mobile__close', function (e){
		e.preventDefault();
		$('.header-mobile').removeClass('header-mobile_opened');
	});
	$b.on('click', '.popup__close', function (e){
		e.preventDefault();
		$('.popup_open').removeClass('popup_open');
	});
	$b.on('click', '.js-catalog', function (e){
		e.preventDefault();
		$('.js-list').slideToggle('slow', function (){
			$('.js-list').toggleClass('page__list_open');
		});
		$(this).toggleClass('catalog-select_active');
	});
	$b.on('click', '.js-sort', function (e){
		e.preventDefault();
		$('.js-filterscnt').removeClass('is-opened');
		$('.js-sort-block').toggleClass('is-opened');
	});
	$b.on('click', '.js-toggle', function (e){
		e.preventDefault();
		$(this).closest('.js-accordion').toggleClass('is-opened');
	});
	$b.on('click', '.js-filter', function (e){
		e.preventDefault();
		$('.js-sort-block').removeClass('is-opened');
		$('.js-filterscnt').toggleClass('is-opened');
	});
	// slider
	const sliders = document.querySelectorAll('.js-range');
	const nouiSliders = [];
	sliders.forEach(function (item, i){
		nouiSliders[i] =
			noUiSlider.create(item, {
				start: [3240, 120000],
				connect: true,
				range: {
					min: 0,
					max: 200000
				}
			});
		sliders[i].noUiSlider.on('update', function (values, handle) {
			const value = values[handle];
			if (handle) {
				document.querySelector('.' + sliders[i].getAttribute('data-max')).value = Math.round(value);
			}else {
				document.querySelector('.' + sliders[i].getAttribute('data-min')).value = Math.round(value);
			}
		});
	});
	$('.jq-number__count').styler();
	// product
	(window.productSlider = function (selector = '.product-inner') {
		const $ss = $(selector);
		const $gallery = $ss.find('.js-gallery');
		$gallery.slick({
			speed: 500,
			fade: false,
			arrows: true,
			cssEase: 'linear'
		});
		$ss.on('click', '.product-thumbs__link', function (e){
			e.preventDefault();
			$ss.find('.product-thumbs__item_active').removeClass('product-thumbs__item_active');
			$ss.find('.js-gallery').slick('slickGoTo', $(this).parent().index());
			$(this).parent().addClass('product-thumbs__item_active');
		});
		$gallery.on('beforeChange', function (event, slick, currentSlide, nextSlide){
			$ss.find('.product-thumbs__item_active').removeClass('product-thumbs__item_active');
			$ss.find('.product-thumbs__item').eq(nextSlide).addClass('product-thumbs__item_active');
		});
	})('.product-inner');
	$b.on('click', '.js-accordion-toggle', function (e){
		e.preventDefault();
		$(this).closest('.accordion').toggleClass('is-opened');
	});
	$b.on('click', '.js-tab', function (e){
		const $t = $(this);
		e.preventDefault();
		if (!$t.hasClass('tabs__link_active')){
			$('.tabs__link_active').removeClass('tabs__link_active');
			$('.tabs__content_active').removeClass('tabs__content_active');
			$t.closest('.tabs').find('.tabs__content').eq($t.addClass('tabs__link_active').index()).addClass('tabs__content_active');
		}
	});
	$b.on('click', '.js-product', function (e){
		e.preventDefault();
		$.fancybox.open(
			{
				src: $(this).attr('href'),
				type: 'ajax',
				touch: false,
				afterShow(){
					window.productSlider('.product-preview');
					$('.product-preview__count').styler();
				}
			}
		);
	});
	$b.on('click', '.js-callback, .js-order, .js-review', function (e){
		e.preventDefault();
		$.fancybox.open(
			{
				src: $(this).attr('href'),
				type: 'ajax',
				touch: false,
				afterShow(){
					$('.form-file__input').styler({
						filePlaceholder: 'Прикрепить файл'
					});
				}
			}
		);
	});
	// drugs
	function resizeWindow(){
		$('.tabs__border').each(function (){
			const $t = $(this);
			$t.width($t.prev('.tabs__inner').innerWidth());
		});
		if ($w.width() >= 1025){
			const $map = $('.contacts__map');
			$map.width('auto');
			$map.width(($w.width() - 1320) / 2 + $map.width() + 20);
		}
	}
	$(window).load(function (){
		resizeWindow();
	});
	$(window).resize(function (){
		resizeWindow();
	});
	// date picker
	const dates = document.querySelectorAll('.form-input_date .form-input__input');
	const datesVars = [];
	for (let i = 0; i < dates.length; i++){
		datesVars[i] = datepicker(dates[i], {
			customDays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
			customMonths: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
			customOverlayMonths: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
			overlayButton: 'Отправить'
		});
		dates[i].parentElement.parentElement.querySelector('.form-input__date').addEventListener('click', e => {
			e.stopPropagation();
			e.preventDefault();
			const isHidden = datesVars[i].calendarContainer.classList.contains('qs-hidden');
			datesVars[i][isHidden ? 'show' : 'hide']();
		});
	}
	function compareCount(){
		$('.js-compareBtn .button__count').text('(' + $('.js-prodChck .form-checkbox__input:checked').length + ')');
	}
	$b.on('change', '.js-prodChck', function (e){
		e.preventDefault();
		$(this).closest('.product_form').toggleClass('product_checked');
		compareCount();
	});
	// sticky table
	$('.compare-table__table').clone(true).appendTo('.compare-table__scroll').addClass('compare-table__table_clone');
	$b.on('click', '.catalog-link__button', function (e){
		e.preventDefault();
		$('.header-sticky__menu_catalog').toggleClass('is-opened');
	});
	$b.on('click', '.js-catalogPopup', function (e){
		e.preventDefault();
		e.stopPropagation();
		$('.js-list').toggleClass('is-opened');
	});
	$b.on('click', '.page__list_dhide, .header-sticky', function (e){
		e.preventDefault();
		e.stopPropagation();
	});
	$b.on('click', function (){
		$('.js-list').removeClass('is-opened');
		$('.header-sticky__menu_catalog').removeClass('is-opened');
	});
});



// WEBPACK FOOTER //
// ./app/scripts/app.js